import React from 'react';
import LeafletWrapper from './leafletWrapper';

function index(props) {
  return (
    <div>
      <LeafletWrapper location={{ ...props }} />
    </div>
  );
}

export default index;
